/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureSqlDatabaseRestoreTarget } from '../models/AzureSqlDatabaseRestoreTarget';

export class AzureSqlDatabaseRestoreDestination {
  'azureSqlDatabase'?: AzureSqlDatabaseRestoreTarget;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "azureSqlDatabase",
      "baseName": "azureSqlDatabase",
      "type": "AzureSqlDatabaseRestoreTarget",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureSqlDatabaseRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

